import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  TranslocoDirective,
  TranslocoPipe,
  TranslocoService,
} from '@jsverse/transloco';
import { TranslateListPipe } from 'src/app/shared/pipes/translate-list.pipe';
import { ClickOutsideDirective } from '../../../shared/directives/click-outside.directive';

@Component({
  selector: 'app-filter-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    ClickOutsideDirective,
    TranslocoDirective,
    TranslocoPipe,
    TranslateListPipe,
  ],
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDropdownComponent implements OnChanges {
  @Input() dropdownItems: FilterDropdownItem[] = [];
  @Input() title: string | undefined;
  @Input() selectedKeys: string[] | undefined;
  @Input() allValuesLabel: string | undefined;
  @Input() hasBorder: boolean | undefined = true;
  @Input() hasPlaceholder: boolean | undefined = true;
  @Input() isHomepage: boolean | undefined = false;
  @Input() iconClasses: string | undefined = '';
  @Output() selectedItem: EventEmitter<string[] | undefined> = new EventEmitter<
    string[] | undefined
  >();

  selectedLabel: string | undefined;
  showResults: boolean = false;
  MultipleSelectedString: string = 'Multiple';
  selectedItems: string[] = [];

  constructor(private translocoService: TranslocoService) {}

  ngOnChanges() {
    this.setDefaultValue();
  }
  setDefaultValue() {
    if (this.selectedKeys) {
      this.selectedItems = this.selectedKeys;
      this.resolveSelection();
    } else {
      this.selectedLabel = this.allValuesLabel;
    }
  }
  ItemSelected(item: FilterDropdownItem) {
    let itemIndex = this.selectedItems.indexOf(item.key);
    if (itemIndex > -1) {
      this.selectedItems.splice(itemIndex, 1);
    } else {
      this.selectedItems.push(item.key);
    }

    this.resolveSelection();
    this.selectedItem.emit(this.selectedItems);
  }

  toggleDropdown() {
    this.showResults = !this.showResults;
  }

  closeDropdown() {
    this.showResults = false;
  }

  private resolveSelection() {
    this.resolveViewLabel();
    this.resolveChecked();
  }

  private resolveViewLabel() {
    if (this.selectedItems.length > 1) {
      this.selectedLabel = this.selectedItems
        .map((item) => this.translocoService.translateObject(item))
        .join(`,`);
    } else if (this.selectedItems.length == 1) {
      this.selectedLabel = this.selectedItems[0];
    } else {
      this.selectedLabel = this.allValuesLabel;
    }
  }
  private resolveChecked() {
    this.dropdownItems = this.dropdownItems.map((x) => ({
      ...x,
      checked: this.selectedItems.includes(x.key),
    }));
  }
}
export interface FilterDropdownItem {
  key: string;
  label: string;
  icon?: string;
  checked?: boolean;
  translation?: string;
}
